import { JSX } from 'react'
import * as Sc from './loader.style'

const Loader: () => JSX.Element = () => {
  return <Sc.Loader data-testid='loader' />
}

export default Loader
